module.exports = __webpack_public_path__ + "img/4.697e7351.jpg";